'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
* A utility class that allows you to place elements directly on the body of the document, instead of placed
*   normally in the DOM. Useful for Modals, Popups, and other elements that need absolute screen positioning.
* See http://joecritchley.svbtle.com/portals-in-reactjs for the Portal concept
*/

var Portal = _react2['default'].createClass({
    displayName: 'Portal',


    propTypes: {
        'rerenderOnUpdate': _react2['default'].PropTypes.bool, // For dynamic components
        'className': _react2['default'].PropTypes.string // Optionally, creates a div to with specified class to wrap child components
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'rerenderOnUpdate': false,
            'className': null
        };
    },

    componentDidMount: function componentDidMount() {
        this.element = document.createElement('div');
        document.body.appendChild(this.element);
        this._renderLayer();
    },

    // FIXME: This should be filled in to adapt to property changes
    componentWillReceiveProps: function componentWillReceiveProps() {},

    componentDidUpdate: function componentDidUpdate() {
        if (this.props.rerenderOnUpdate) {
            this._renderLayer();
        }
    },

    componentWillUnmount: function componentWillUnmount() {
        _reactDom2['default'].unmountComponentAtNode(this.element);
        document.body.removeChild(this.element);
    },

    _renderLayer: function _renderLayer() {
        if (this.props.className) {
            _reactDom2['default'].render(_jsx('div', {
                className: this.props.className
            }, void 0, this.props.children), this.element);
        } else {
            _reactDom2['default'].render(this.props.children, this.element);
        }
    },

    // Placeholder to satisfy render
    render: function render() {
        return null;
    }

});

module.exports = Portal;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/portal.jsx
 ** module id = 688
 ** module chunks = 0
 **/